(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

/*Header*/
document.getElementById("menuToggle").addEventListener("click", function () {
  var menu = document.getElementById("menu");
  menu.classList.toggle("open");
});
var lastScrollTop = 0,
  navbar = document.querySelector(".scroll-to-see");
window.addEventListener("scroll", function () {
  var t = window.pageYOffset || document.documentElement.scrollTop;
  if (!navbar) return;
  t > lastScrollTop && t > 100 ? navbar.style.transform = "translateY(-100%)" : navbar.style.transform = "translateY(0)";
  navbar.style.transition = "transform 0.3s ease-in-out";
  lastScrollTop = t <= 0 ? 0 : t;
});

/*Header*/

/*HomePage*/
document.addEventListener("DOMContentLoaded", function () {
  var headEl = document.getElementById("homehead");
  if (!headEl) return; // exit if element not found

  headEl.style.transition = "color 0.5s ease";
  var isRed = false;

  // initial color
  headEl.style.color = "#56147b";
  setInterval(function () {
    headEl.style.color = isRed ? "#56147b" : "#000";
    isRed = !isRed;
  }, 3000);
});

/*HomePage*/

/*Swiper Js*/

/*HomePage follow us RightSwiper */

var swiper = new Swiper(".rightSwiper", {
  speed: 3000,
  loop: true,
  slidesPerView: 2,
  spaceBetween: 10,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
    reverseDirection: true
  },
  breakpoints: {
    768: {
      slidesPerView: 4,
      spaceBetween: 20
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: 20
    },
    1280: {
      slidesPerView: 5,
      spaceBetween: 20
    },
    1440: {
      slidesPerView: 6,
      spaceBetween: 30
    },
    1920: {
      slidesPerView: 6,
      spaceBetween: 40
    }
  },
  freeMode: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  }
});

/*HomePage follow us RightSwiper */

/*HomePage followus LeftSwiper */

var swiper = new Swiper(".leftSwiper", {
  speed: 5000,
  loop: true,
  slidesPerView: 1,
  spaceBetween: 10,
  autoplay: {
    delay: 0,
    disableOnInteraction: false
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    1280: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    1440: {
      slidesPerView: 4,
      spaceBetween: 30
    },
    1920: {
      slidesPerView: 4,
      spaceBetween: 40
    }
  },
  freeMode: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  }
});

/*HomePage followus LeftSwiper */

/*Swiper Js*/

/*gsap*/

document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollTrigger);

  // Animate on homepage
  if (document.querySelector(".animate-me")) {
    gsap.from(".animate-me", {
      opacity: 0,
      y: 50,
      duration: 1.5,
      ease: "power3.out"
    });
  }
  if (document.querySelector(".slide-2__heading")) {
    gsap.fromTo(".slide-2__heading", {
      x: -800
    }, {
      x: 0,
      scrollTrigger: {
        trigger: ".slide-2",
        start: "top 50%",
        end: "top top",
        scrub: true
        // markers: true,
      }
    });
  }
  if (document.querySelector(".slide-2__heading--sub")) {
    gsap.fromTo(".slide-2__heading--sub", {
      x: 800
    }, {
      x: 0,
      scrollTrigger: {
        trigger: ".slide-2",
        start: "top 50%",
        end: "top top",
        scrub: true
        // markers: true,
      }
    });
  }
  console.log("✅ GSAP loaded and animations registered where applicable.");
});
console.log("✅ I am Loading Don't Worry Buddy");

/*gsap*/

},{}]},{},[1]);
